import { compact, isEmpty, trim } from "lodash";

export default function dnzNil(value) {
  return (
    value == "Unknown" ||
    value == "Not specified" ||
    isEmpty(compact(trim(value)))
  );
}
